import * as styles from 'haven-design-system/build/typescript/es6';

export const base = {
  mainBlack: styles.colorBaseBlackPrimary,
  softBlack: styles.colorBaseBlackLight,
  mainGray: styles.colorBaseGreyDark,
  shadeGray: styles.colorBaseGreyPrimary,
  lightGray: styles.colorBaseGreyLight,
  bgGray: styles.colorBaseWhiteDark,
  white: styles.colorBaseWhitePrimary,
  black: styles.colorBaseBlackDark,
};

export const primary = {
  midBlue: styles.colorBaseBluePrimary,
  lightMidBlue: styles.colorBaseBlueLight,
  deepBlue: styles.colorBaseBlueDark,
  green: styles.colorBaseGreenPrimary,
  darkGreen: styles.colorBaseGreenDark,
  lightGreen: styles.colorBaseGreenLight,
};

export const secondary = {
  purple: styles.colorBasePurplePrimary,
  darkPurple: styles.colorBasePurpleDark,
  lightPurple: styles.colorBasePurpleLight,
  softTeal: styles.colorBaseTealLight,
  darkSoftTeal: styles.colorBaseTealPrimary,
  lightSoftTeal: styles.colorBaseTealLight,
  teal: styles.colorBaseTealPrimary,
  darkTeal: styles.colorBaseTealDark,
  lightTeal: styles.colorBaseTealLight,
  orange: styles.colorBaseTealPrimary,
  darkOrange: styles.colorBaseOrangeDark,
  lightOrange: styles.colorBaseOrangeLight,
  sand: styles.colorBaseSandPrimary,
  darkSand: styles.colorBaseSandDark,
  lightSand: styles.colorBaseSandLight,
  red: styles.colorBaseRedPrimary,
  darkRed: styles.colorBaseRedDark,
  lightRed: styles.colorBaseRedLight,
  yellow: styles.colorBaseYellowPrimary,
  darkYellow: styles.colorBaseYellowDark,
  lightYellow: styles.colorBaseYellowLight,
};

export const severities = {
  severity: {
    monitor: {
      text: styles.colorSeverityMonitorDark,
      background: styles.colorSeverityMonitorLight,
    },
    repair: {
      text: styles.colorSeverityRepairDark,
      background: styles.colorSeverityRepairLight,
    },
    safety: {
      text: styles.colorSeveritySafetyDark,
      background: styles.colorSeveritySafetyLight,
    },
    other: {
      text: styles.colorSeverityMonitorDark,
      background: styles.colorSeverityMonitorLight,
    },
  },
};

export const mediaVault = {
  subsystem: base.mainGray,
  information: base.mainBlack,
  deficiency: secondary.darkRed,
  limitation: primary.midBlue,
};

export default {
  ...base,
  ...primary,
  ...secondary,
  ...severities,
  ...mediaVault,
};
